export function validateIndonesianPhoneNumber(phoneNumber) {
  const regex = /^(\+62|062|62)?\s?0?8(1[0-9]|2[0-2]|3[0-9]|4[0-8]|5[0-9]|6[0-9]|7[0-9]|9[0-9])[0-9]{6,11}$/;
  return regex.test(phoneNumber);
}



// WEBPACK FOOTER //
// ./src/utils/phoneNumberValidation.js